import { Link as LinkR } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'

export const LibraryContainer = styled.div`
  background: #f5f5f5;
  color: #000;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 100px 10px 10px 12px;
  width: flex;
  position: relative;
  overflow: hidden;
  background: linear-gradient(
    108deg,
    rgba(194, 178, 128, 1) 0%,
    rgb(220, 222, 216) 100%
  );
  min-height: 81vh;

  @media screen and (max-width: 490px){
    position: unset;
  }
`;

export const LibraryShelf = styled.div`
  max-width: 2000px;
  color: #000;
  display: flex;
  justify-content: Top;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  border:3px solid white;
  min-height: 700px;
  max-width: 95%;
  padding: 7px;

  @media screen and (min-width: 490px){
    min-width: 1000px;
    min-height: 700px;
  }
`;

export const ShelfTitle = styled.div`
  color: #ffffff;
  padding: 12px;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 1.4px;
  text-transform: uppercase;
`;

export const BookRow = styled.div`
  display: inline-flex;
  background: white;
  flex-direction: row;
  margin-top: 20px;
  padding: 20px;
  grid-gap: 20px;
  justify-content: center;
  margin-right: 2px;
  margin-left: 2px;
  max-width: 95%;
  align-items: center;
  
  @media screen and (min-width: 490px){
    justify-content: space-around;
    min-width: 900px;
    grid-template-columns: 400px 800px;
    padding: 20px;
  }
`;

export const BookThumbnail = styled.video`
 width: 200px;
//  -o-object-fit: cover;
//  object-fit: cover;
//  background: #232a34;
 justify-content: center;
 @media screen and (max-width: 490px){
    justify-content: space-around;
    width: 150px;
    height: 150px;
  }
`;

export const BookThumbnailImage = styled.img`
 width: 200px;
//  -o-object-fit: cover;
//  object-fit: cover;
//  background: #232a34;
 justify-content: center;

   @media screen and (max-width: 490px){
    justify-content: space-around;
    width: 150px;
    height: 150px;
  }
`;


export const BookDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 500px;
  align-items: center;

  @media screen and (min-width: 490px){
    text-align: center
  }
`;

export const BookTitle = styled.div`
  color: #c2b280;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-top: 0px;
  margin-bottom: 6px;
  
`;

export const BookDetails = styled.p`
  width: 90%;
  font-size: 12px;
  line-height: 12px;
  color: black;
  margin-bottom: 6px;
`;


export const BtnWrap = styled.div`
  display: flex;
  justify-content: center;
`;

export const LibraryButton = styled(LinkR)`
  border-radius: 50px;
  background: #c2b280;
  white-space: nowrap;
  padding: 2px 8px;
  color: #ffffff;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;
  margin-top:2px;
  min-width: 100px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #c2b280;
  }

   @media screen and (min-width: 490px){
    min-width: 200px;
  }
`;

export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const SpinningIcon = styled(AiOutlineLoading3Quarters)`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #c2b280;
  border-radius: 50%; 
  width: 24px; 
  height: 24px; 
  animation: ${spin} 1s linear infinite;
`